<template>
    <div class="tco-tool__popout-grid-trims">
        <label class="tco-tool__popout-label">Choose your trim</label>
        <p v-if="!selectedModel">Please choose a model first</p>
        <div class="tco-tool__popout-grid-trim-list" v-else>
            <div class="tco-tool__popout-grid-model" :class="{'tco-tool__popout-grid-model--selected': (selectedTrim && selectedTrim.id == trim.id) }" v-for="trim in availableTrims" :key="trim.id" @click="selectTrim(trim)">
                <picture>
                    <source v-if="trim.image_webp" :srcset="trim.image_webp" type="image/webp">
                    <img :srcset="trim.image" :alt="trim.trim" class="img-responsive tco-tool__popout-grid-model-img">
                </picture>
                <h4 class="tco-tool__popout-grid-model-title">{{ trim.trim }}</h4>
                <h5 class="tco-tool__popout-grid-model-price" v-if="trim.from">from <span>{{ trim.formattedFrom }}</span></h5>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import NumberFormat from '../../../../used-vue/api/NumberFormat';
import { customEvent } from '../../../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        brand: {
            required: true,
            type: Object
        },
        isElectric: {
            required: false,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        ...mapMutations(['setSelectedEvTrim', 'setSelectedIceTrim', 'setSelectedEvVehicle', 'setSelectedIceVehicle']),
        selectTrim(trim, isUserInteraction = true) {
            if (this.isElectric) {
                if (!trim || !this.selectedTrim || trim.id != this.selectedTrim.id) {
                    this.setSelectedEvVehicle(null);
                }
                this.setSelectedEvTrim(trim);
                if (isUserInteraction) {
                    customEvent('TCO', 'Clicked', 'Step 2.2 - ' + this.brand.brand + ' ' + this.selectedModel.electric_model_title + ' ' + trim.trim);
                }
                return;
            }

            if (!trim || !this.selectedTrim || trim.id != this.selectedTrim.id) {
                this.setSelectedIceVehicle(null);
            }
            this.setSelectedIceTrim(trim);
            if (isUserInteraction) {
                customEvent('TCO', 'Clicked', 'Step 3.2 - ' + this.brand.brand + ' ' + this.selectedModel.short_name + ' ' + trim.trim);
            }
            return
        }
    },
    computed: {
        ...mapState(['selectedEvModel', 'selectedIceModel', 'selectedEvTrim', 'selectedIceTrim']),
        selectedModel() {
            if (this.isElectric) {
                return this.selectedEvModel;
            }
            return this.selectedIceModel;
        },
        selectedTrim() {
            if (this.isElectric) {
                return this.selectedEvTrim;
            }
            return this.selectedIceTrim;
        },
        availableTrims() {
            if (!this.selectedModel) {
                return [];
            }
            const newVehiclesLength = this.selectedModel.new_vehicles.length;
            if (newVehiclesLength == 0) {
                return false;
            }
            const availableTrims = {};
            let firstAvailableTrim = null;

            for (let index = 0; index < newVehiclesLength; index++) {
                const newVehicle = this.selectedModel.new_vehicles[index];
                if (typeof newVehicle.new_vehicles_trim == 'undefined' || !newVehicle.new_vehicles_trim) {
                    console.error('Vehicle unexpectedly missing new_vehicles_trim');
                    continue;
                }

                const fuel = newVehicle.fuel_type.toLowerCase();
                if (this.isElectric) {
                    if (!fuel.includes('electric')) {
                        continue;
                    }

                    if (firstAvailableTrim === null) {
                        firstAvailableTrim = newVehicle.new_vehicles_trim.trim;
                    }

                    if (typeof availableTrims[newVehicle.new_vehicles_trim.trim] == 'undefined') {
                        availableTrims[newVehicle.new_vehicles_trim.trim] = {
                            ...newVehicle.new_vehicles_trim,
                            from: newVehicle.pricing_display_price,
                            formattedFrom: '£' + NumberFormat(newVehicle.pricing_display_price)
                        };
                        continue;
                    }
                    if (newVehicle.pricing_display_price < availableTrims[newVehicle.new_vehicles_trim.trim].from) {
                        availableTrims[newVehicle.new_vehicles_trim.trim].from = newVehicle.pricing_display_price;
                        availableTrims[newVehicle.new_vehicles_trim.trim].formattedFrom = '£' + NumberFormat(newVehicle.pricing_display_price)
                    }
                    continue;
                }

                if (fuel.includes('electric')) {
                    continue;
                }

                if (firstAvailableTrim === null) {
                    firstAvailableTrim = newVehicle.new_vehicles_trim.trim;
                }

                if (typeof availableTrims[newVehicle.new_vehicles_trim.trim] == 'undefined') {
                    availableTrims[newVehicle.new_vehicles_trim.trim] = {
                        ...newVehicle.new_vehicles_trim,
                        from: newVehicle.pricing_display_price,
                        formattedFrom: '£' + NumberFormat(newVehicle.pricing_display_price)
                    };
                    continue;
                }

                if (newVehicle.pricing_display_price < availableTrims[newVehicle.new_vehicles_trim.trim].from) {
                    availableTrims[newVehicle.new_vehicles_trim.trim].from = newVehicle.pricing_display_price;
                    availableTrims[newVehicle.new_vehicles_trim.trim].formattedFrom = '£' + NumberFormat(newVehicle.pricing_display_price)
                }
            }

            if (!this.selectedTrim && firstAvailableTrim) {
                this.selectTrim(availableTrims[firstAvailableTrim], false);
            }
            return availableTrims;
        }
    },
}
</script>